import React from "react";
import { useRouteError, Link } from "react-router";
import logo from "../../images/logo-full.png";

const ErrorPage = ({ fullPage = false }) => {
  const error = useRouteError();

  return (
    <div className={`error-page${fullPage ? " full-page" : ""}`}>
      {fullPage && <img src={logo} className="error-logo" alt="Site logo" />}
      {error?.status === 404 ? (
        <>
          <p className="error-title">404</p>
          <p className="error-subtitle">Got a blank space...</p>
        </>
      ) : (
        <>
          <p className="error-title">500</p>
          <p className="error-subtitle">We are so very sorry...</p>
        </>
      )}
      <p className="error-detail">
        {error?.data || "An unexpected error has occurred"}
      </p>

      <Link to="/" className="button">Return Home</Link>
    </div>
  );
};

export default ErrorPage;
